import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=5810463e&scoped=true"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts"
import style0 from "./CopyToClipboard.vue?vue&type=style&index=0&id=5810463e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5810463e",
  null
  
)

export default component.exports